import request from '@/utils/request'

export function userCatalogue(params) {
    return request({
      url: 'product/userCatalogue',
      method: 'get',
        params
    })
  }
  